















































import { Component, Vue } from 'vue-property-decorator'
import { appModule } from '@/store/module/AppModule'

@Component({
  name: 'LangSelect'
})
export default class extends Vue {
  get language() {
    return appModule.config.language
  }

  private handleSetLanguage(lang: string) {
    this.$i18n.locale = lang
    appModule.setLanguage(lang)
  }
}
